<div class="card overflow-auto flex flex-col md:flex-row sm:mr-2">
  <div class="p-gutter flex-auto max-w-[1000px]">
    <h3 class="body-2 m-0">Setup</h3>

    <div #operationOriginRef class="mt-4 row ">
      <span *ngFor="let operation  of operations" class="col cursorP">
        <a (click)="processOp(operation.route,operationOriginRef)"
          [class.disabled]="this.operationStatus.isOperationDisabled(operation.route,operation.id)"
          class="text-dark cursorP pt-3 text-center hover:bg-primary/10 hover:text-primary trans-ease-out rounded block no-underline">
          <mat-icon [svgIcon]="operation.icon" class="icon-xl" color="primary"></mat-icon>
          <div class="body-2 cursorP mt-2">{{ operation.label }}</div>
        </a>
      </span>
    </div>
  </div>
</div>